module.exports = __webpack_public_path__ + "static/help_pic.c225a45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help_pic.png
// module id = 3121
// module chunks = 174994552580003